var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"700px"}},[_c('organ-info-view',{staticClass:"my-3",attrs:{"organ-id":_vm.organId,"show-warning-text":true}}),_c('organ-seal-edit',{attrs:{"organ-id":_vm.organId}}),_c('organ-contact-person-edit',{staticClass:"my-3",attrs:{"owner-id":_vm.organId,"person-type":_vm.personType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }